<template>
  <v-ons-page id="landing-page" class="page-column">
    <v-ons-toolbar class="home-toolbar toolbar--cover-content" modifier="transparent" style="border-bottom:none">
      <div class="left">
        <v-ons-toolbar-button @click="toggleMainMenu">
          <v-ons-icon icon="ion-navicon, material:md-menu"></v-ons-icon>
        </v-ons-toolbar-button>
      </div>
      <div class="center"></div>
      <div class="right">
        <v-ons-toolbar-button v-show="showUpdateAlert" @click="checkUpdate()">
          <v-ons-icon icon="fa-bell-0"></v-ons-icon>
        </v-ons-toolbar-button>
      </div>
    </v-ons-toolbar>

    <div class="header">
      <div id="logo">

      </div>
    </div>

    <div class="flex-row flex-wrap flex-grow overflow-hidden background-image">
      <v-ons-card @click="push(type)" v-for="type in types" :key="type.title">
        <div class="background-cover flex-grow" :class="type.class"></div>
        <div class="title">
          <span style="white-space: nowrap;">{{ type.title }}</span>
        </div>
      </v-ons-card>
    </div>

  </v-ons-page>
</template>

<script>
import Filters from './Filters.vue'
import { appData } from '../data.js'

export default {
  name: 'home',
  props: {

  },
  data () {
    return {
      types: appData.state.types,
      showUpdateAlert: false,
      state: appData.state
    }
  },
  methods: {
    toggleMainMenu() {
      this.$emit('toggleMainMenu');
    },
    push(type) {
      this.$emit('push-page', {
        extends: Filters,
        onsNavigatorProps: {
          type: type
        }
      });
    },
    checkUpdate() {
      this.$ons.notification.confirm('Updates are available. Would you like to get them now?')
        .then(response => {
          if(response == 1) {
            console.log(response);
            this.$emit('refreshContent');
          }
        });
    }
  },
  watch: {
    state: {
      handler: function (val, oldVal) {
        //console.log(val.showUpdateAlert, val.showUpdateAlert);
        this.showUpdateAlert = val.showUpdateAlert;
      },
      deep: true
    }
  },
  computed: {

  },
  created() {

  }
}
</script>

<style scoped>
  * {
    box-sizing: border-box;
  }

  .header {
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding: 10px;
    flex: none;
  }

  .header img {
    display: block;
    max-width: 300px;
    max-height: 100px;
    height: auto;
    width: auto;
  }

  ons-list-title {
    text-transform: none;
  }

  ons-list-title:not(:first-of-type) {
    margin-top: 30px;
  }

  ons-card {
    text-align: center;
    flex: 1 1 40%;
    display: flex;
    flex-direction: column;
    padding: 10px;
    padding: 6px;
  }

  ons-card img {
    width: 100%;
  }

  .background-cover {
    width: 100%;
    background-size: contain;
    background-position: 50% 50%;
    background-repeat: no-repeat;
  }

  ons-card > * {
    font-size: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Landing.vue